import React from 'react';
import { useTranslation } from 'react-i18next';
import { Target, AlertCircle, Loader2 } from 'lucide-react';
import { cn } from '@/shared/lib/utils';

interface GoalsTreeEmptyProps {
  message: string;
  variant?: 'loading' | 'error' | 'empty';
}

export const GoalsTreeEmpty: React.FC<GoalsTreeEmptyProps> = ({
  message,
  variant = 'empty',
}) => {
  const { t } = useTranslation('goals');
  const configs = {
    loading: {
      icon: Loader2,
      iconClass: 'text-blue-500 animate-spin',
      bgClass: 'bg-blue-50',
      textClass: 'text-gray-700',
    },
    error: {
      icon: AlertCircle,
      iconClass: 'text-red-500',
      bgClass: 'bg-red-50',
      textClass: 'text-red-700',
    },
    empty: {
      icon: Target,
      iconClass: 'text-gray-400',
      bgClass: 'bg-gray-50',
      textClass: 'text-gray-600',
    },
  };

  const config = configs[variant];
  const Icon = config.icon;

  return (
    <div className="flex items-center justify-center py-16">
      <div className="text-center max-w-md">
        <div
          className={cn('inline-flex p-4 rounded-full mb-4', config.bgClass)}
        >
          <Icon className={cn('h-12 w-12', config.iconClass)} />
        </div>
        <p className={cn('text-base font-medium', config.textClass)}>
          {message}
        </p>
        {variant === 'empty' && (
          <p className="text-sm text-gray-500 mt-2">{t('createFirstGoal')}</p>
        )}
      </div>
    </div>
  );
};
